import { render } from "./Tab.vue?vue&type=template&id=07e15390&scoped=true"
import script from "./Tab.vue?vue&type=script&lang=js"
export * from "./Tab.vue?vue&type=script&lang=js"

import "./Tab.vue?vue&type=style&index=0&id=07e15390&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-07e15390"

export default script